import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseSm = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.875 11.875L3.125 3.125M11.875 3.125L7.5 7.5L3.125 11.875",
		stroke: "#C25254",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCloseSm;
